module.exports = __webpack_public_path__ + "img/download-linux-app-btn.4f209db7.png";